import { Link, useNavigate } from 'react-router-dom'
import BlockHomeForm from '../../components/BlockHomeForm'
import Header from '../../components/Header'
import Page from '../../components/Page'
import { useCreateBlockHome } from '../../hooks/blocks-home'

export default function BlockHomePageCreate() {
  const createBlock = useCreateBlockHome()
  const navigate = useNavigate()

  return (
    <Page>
      <Header margins>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/blocks-home-page">Blocchi Home Page</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Aggiungi
            </li>
          </ol>
        </nav>
      </Header>
      <div className="py-3 overflow-y-auto flex-1">
        <BlockHomeForm
          save={async (block) => {
            const savedBlock = await createBlock.mutateAsync(block)
            navigate(`/blocks-home-page/${savedBlock.id}`)
          }}
        />
      </div>
    </Page>
  )
}
